import { render, staticRenderFns } from "./CategoryCardList.vue?vue&type=template&id=2b419982&scoped=true"
import script from "./CategoryCardList.vue?vue&type=script&lang=js"
export * from "./CategoryCardList.vue?vue&type=script&lang=js"
import style0 from "./CategoryCardList.vue?vue&type=style&index=0&id=2b419982&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b419982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b419982')) {
      api.createRecord('2b419982', component.options)
    } else {
      api.reload('2b419982', component.options)
    }
    module.hot.accept("./CategoryCardList.vue?vue&type=template&id=2b419982&scoped=true", function () {
      api.rerender('2b419982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/CategoryCardList.vue"
export default component.exports